import { S as Select } from './Select-dbb12e54.esm.js';
export { c as createFilter, d as defaultTheme } from './Select-dbb12e54.esm.js';
import { m as manageState } from './stateManager-845a3300.esm.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/inherits';
import 'react';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/taggedTemplateLiteral';
import '@babel/runtime/helpers/typeof';
import '../../react-input-autosize/lib/AutosizeInput.js';
import '@babel/runtime/helpers/defineProperty';
import 'react-dom';
var index = manageState(Select);
var ReactSelect = index;
export { ReactSelect as default };